import { CashoutStatus } from '@/types';
export const mainDomain = import.meta.env.VITE_DOMAIN;
export const siteName = import.meta.env.VITE_DOMAIN.split('.')[0];
export const cacheAge = 1000 * 60 * import.meta.env.VITE_CACHE_AGE; // 30 минут
export const storageDomain = import.meta.env.VITE_STORAGE_DOMAIN;
export const defaultCurrency = import.meta.env.VITE_DEFAULT_CURRENCY;
export const startPage = 1;
export const startSize = 25;
export const documentStatuses = {
    none: 0,
    pending: 1,
    verified: 2,
    rejected: 3
};
export const sexOptions = [
    { value: 'male', text: 'male' },
    { value: 'female', text: 'female' },
    { value: 'other', text: 'other' }
];
export const paymentStatuses = {
    processing: CashoutStatus.PROCESSING,
    processed: CashoutStatus.PROCESSED,
    processedWithFee: CashoutStatus.PROCESSED_WITH_FEE,
    rejected: CashoutStatus.REJECTED,
    manually: CashoutStatus.MANUALLY
};
export const maxPlayerDateAge = () => {
    const now = new Date();
    return new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());
};
export const maxDate = maxPlayerDateAge();
export const getSelfExclusionOptions = (currentDay) => {
    const toGetFormattedDate = (date) => {
        return date.toISOString().split('T')[0];
    };
    return [
        { label: 'day', value: toGetFormattedDate(new Date(currentDay.setDate(currentDay.getDate() + 1))) },
        { label: 'week', value: toGetFormattedDate(new Date(currentDay.setDate(currentDay.getDate() + 7))) },
        { label: 'month', value: toGetFormattedDate(new Date(currentDay.setDate(currentDay.getDate() + 30))) },
        { label: 'half_year', value: toGetFormattedDate(new Date(currentDay.setDate(currentDay.getDate() + 180))) },
        { label: 'year', value: toGetFormattedDate(new Date(currentDay.setDate(currentDay.getDate() + 365))) },
        { label: 'forever', value: null }
    ];
};
export const limitDurationOptions = [
    { label: 'day', value: 'day' },
    { label: 'week', value: 'week' },
    { label: 'month', value: 'month' }
];
export const spinCircles = [
    { id: 1, isLeft: true },
    { id: 2, isLeft: false },
    { id: 3, isLeft: true },
    { id: 4, isLeft: false },
    { id: 5, isLeft: true }
];
